export default __webpack_public_path__ + "static/media/noChat.4856994c.jpg";